import React from 'react';

import OnboardingCard from 'components/rewards/onboarding-card';
import RewardsHeader from 'components/rewards/rewards-header';
import { useLoyaltyActiveCard } from 'hooks/loyalty';
import { useAuthContext } from 'state/auth';
import { ENABLE_LOYALTY_20_ON_BOARDING_CONTENT_CARD_ON_THE_HOME_PAGE } from 'utils/constants';

interface ILoyaltyHero {
  actionTo: string;
  heroSuperText?: string;
  heroActionText: string;
  heroSubText?: string;
}

const LoyaltyHero = ({ actionTo, heroActionText }: ILoyaltyHero) => {
  const { loading, loyaltyDetails } = useLoyaltyActiveCard();
  const { user } = useAuthContext();
  const loyaltyTier = user?.details?.loyaltyTier;
  const showOnBoarding =
    ENABLE_LOYALTY_20_ON_BOARDING_CONTENT_CARD_ON_THE_HOME_PAGE && !loyaltyTier;

  return (
    <>
      <RewardsHeader
        isLoading={loading}
        actionTo={actionTo}
        actionText={heroActionText}
        loyaltyDetails={loyaltyDetails}
      />
      {showOnBoarding && <OnboardingCard />}
    </>
  );
};

export default LoyaltyHero;
